import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import {
  BANK_VERIFICATION_BANNER,
  BANK_VERIFICATION_NEEDED,
  trackBannerViewed,
  trackButtonClicked,
} from 'components/Services/Analytics/TrackEventsService';

const ACCOUNT_VERIFICATION_MESSAGE = 'Your bank account information needs to be verified to continue receiving \
payouts. Head over to My Money to verify your information.';

const ErrorBar = ({ message, bannerProps }) => {
  const dispatch = useDispatch();
  const isBankVerificationBanner = message === ACCOUNT_VERIFICATION_MESSAGE;

  useEffect(() => {
    if (isBankVerificationBanner) {
      dispatch(trackBannerViewed(BANK_VERIFICATION_NEEDED));
    }
  }, [message]);

  const { onClick, className } = bannerProps;
  const onBannerClicked = () => {
    if (isBankVerificationBanner) {
      dispatch(trackButtonClicked(BANK_VERIFICATION_BANNER));
    }
    onClick();
  };

  return (
    <div onClick={onBannerClicked} className={className}>
      <Alert severity="error">
        <div dangerouslySetInnerHTML={{__html: message}}/>
      </Alert>
    </div>
  )
};

ErrorBar.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  hasHeader: PropTypes.bool,
  bannerProps: PropTypes.object,
};

export default ErrorBar;
